import { Component, OnDestroy, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from '../../../shared/services/theme.service';
import { SystemImageStore } from '../../../core/store/system-image.store';

@Component({
  selector: 'ngx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent implements OnInit, OnDestroy {
  logoSrc: string;
  private themeSubscription: Subscription;
  readonly systemImageStore = inject(SystemImageStore);

  constructor(private themeService: ThemeService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.themeSubscription = this.themeService.currentTheme$.subscribe((theme) => {
      this.updateLogo(theme);
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  private updateLogo(theme: string) {
    // this.logoSrc =
    //   theme === 'dark' || theme === 'cosmic' ? './assets/images/logo-white.png' : './assets/images/logo-red.png';
    this.logoSrc = './assets/images/logo-red.png'; // Use the red logo for all themes as per the requirement
  }
}
